var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyfile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 301,
    viewBox: "0 0 421 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.113 273.635C142.392 273.635 176.666 268.362 176.666 261.858C176.666 255.354 142.392 250.081 100.113 250.081C57.8341 250.081 23.5603 255.354 23.5603 261.858C23.5603 268.362 57.8341 273.635 100.113 273.635Z",
    fill: "#DFDFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.237 275.992C301.616 275.992 363.533 270.719 363.533 264.215C363.533 257.71 301.616 252.438 225.237 252.438C148.858 252.438 86.9401 257.71 86.9401 264.215C86.9401 270.719 148.858 275.992 225.237 275.992Z",
    fill: "#DFDFEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.649 60.3937C249.649 60.3937 246.144 75.0542 226.311 92.9418C226.311 92.9418 224.418 90.2645 228.652 79.9471C232.887 69.6304 248.818 56.7358 249.649 60.3937Z",
    fill: "#737472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.649 60.3945C249.649 60.3945 232.136 71.2991 226.311 92.9426C226.311 92.9426 224.973 100.408 227.132 107.088",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.871 69.4846C203.871 69.4846 208.797 66.2258 201.284 56.817C194.148 47.8786 186.505 39.7846 170.795 35.9912C170.795 35.9912 174.211 57.8177 184.235 63.6112C194.259 69.4039 203.871 69.4846 203.871 69.4846Z",
    fill: "#737472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.295 82.8356C164.295 82.8356 180.639 87.5137 209.353 79.9342C209.353 79.9342 207.797 76.9161 195.297 75.1336C182.798 73.3511 161.178 80.2109 164.295 82.8356Z",
    fill: "#737472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.295 82.8356C164.295 82.8356 184.857 73.5824 209.353 79.9342C209.353 79.9342 211.863 80.7361 214.239 84.3724",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.071 98.7338C177.071 98.7338 194.06 111.547 222.774 103.967C222.774 103.967 217.941 93.7264 205.442 91.9439C192.943 90.1615 173.954 96.1091 177.071 98.7338Z",
    fill: "#737472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.071 98.7345C177.071 98.7345 196.761 91.0397 222.774 103.968C222.774 103.968 225.828 105.569 228.203 109.205",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.756 45.7302C240.756 45.7302 246.03 45.4384 232.498 56.4374C219.72 66.8226 221.248 67.0084 221.248 67.0084C221.248 67.0084 226.896 50.6043 240.756 45.7302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.111 72.0982C212.111 72.0982 215.924 73.8562 223.391 67.8365C230.858 61.8168 234.412 47.562 240.756 45.7305C240.756 45.7305 224.876 49.7587 212.111 72.0982Z",
    fill: "#737472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.576 123.298C227.649 106.766 217.772 87.8549 203.872 69.4846C203.872 69.4846 200.493 64.4167 188.478 51.071C176.464 37.7254 170.797 35.9912 170.797 35.9912",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.869 46.3809C238.869 46.3809 223.651 51.8919 212.111 72.098C209.316 76.993 212.016 81.1819 214.238 84.3723",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.944 236.795C392.944 236.795 378.185 241.225 353.557 225.265C353.557 225.265 355.174 220.977 366.314 220.287C377.453 219.597 395.902 233.347 392.944 236.795Z",
    fill: "#737472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.392 235.711C392.392 235.711 376.179 222.953 353.845 224.842C353.845 224.842 346.37 226.124 340.824 230.428",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.819 203.898C360.819 203.898 365.559 207.421 371.851 197.156C377.827 187.404 382.838 177.463 381.059 161.399C381.059 161.399 361.697 172.038 359.661 183.435C357.623 194.832 360.819 203.898 360.819 203.898Z",
    fill: "#737472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.888 222.235C398.888 222.235 401.987 226.514 385.416 221.082C369.769 215.954 370.44 217.338 370.44 217.338C370.44 217.338 387.292 213.214 398.888 222.235Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.216 212.408C361.216 212.408 361.799 216.566 370.902 219.59C380.005 222.614 393.916 217.891 398.888 222.236C398.888 222.236 386.909 211.059 361.216 212.408Z",
    fill: "#737472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.664 251.082C333.853 238.943 348.274 223.221 360.819 203.898C360.819 203.898 364.434 198.996 372.896 183.157C381.357 167.319 381.059 161.399 381.059 161.399",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.32 221.001C397.32 221.001 384.452 211.183 361.216 212.408C355.587 212.704 353.037 215.445 348.817 220.708",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.461 89.9032C243.977 89.9032 248.35 88.3181 251.818 85.4246L261.44 77.3955C264.903 74.5063 269.015 72.958 273.229 72.958H320.982C325.315 72.958 328.828 76.4711 328.828 80.8041V89.9025V253.681C328.828 261.158 322.767 267.221 315.289 267.221H77.2448C71.429 267.221 66.7141 262.506 66.7141 256.69V100.434C66.7141 94.6181 71.429 89.9032 77.2448 89.9032H239.461Z",
    fill: "#3F4042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7149 257.573C66.7149 257.573 82.9151 227.185 84.5355 223.695L128.81 133.496C129.923 131.098 132.326 129.565 134.968 129.565H299.498C305.479 129.565 314.13 126.43 318.723 122.597L325.362 117.058C328.825 114.168 332.938 112.62 337.151 112.62H382.595C387.433 112.62 390.718 117.534 388.87 122.004L333.918 254.912C330.838 262.362 323.571 267.221 315.509 267.221H69.6862C68.0838 267.221 66.604 265.849 66.6047 264.246L66.7149 257.573Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.637 138.142L68.6691 264.434",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.407 159.906H216.371C217.897 159.906 219.317 159.138 220.137 157.87C222.027 154.944 219.893 151.114 216.371 151.114H160.407C158.881 151.114 157.461 151.882 156.642 153.15C154.751 156.076 156.886 159.906 160.407 159.906Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.094 203.312L221.521 229.272",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.469 202.061L256.848 229.428",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.437 239.953C267.877 235.129 279.06 220.537 275.416 207.361C271.771 194.185 254.679 187.415 237.239 192.239C219.799 197.063 208.616 211.655 212.261 224.831C215.905 238.007 232.998 244.777 250.437 239.953Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyfile1);
export default __webpack_public_path__ + "static/media/Emptyfile1.c94a7bc576475f959799111a7af6deb3.svg";
export { ForwardRef as ReactComponent };